export default __webpack_public_path__ + "static/media/heathcare.98f47bce.jpg";